import { List } from '@components/IRISPaymentHistory/List.component';
import { IRISPaymentHistoryItem } from '@components/IRISPaymentHistory/models/IRISPaymentHistoryDTO.model';
import { TopNavigationActions } from '@components/TopNavigationActions/TopNavigationActions.component';
import {
  PAGER_FIRST_PAGE,
  PAGER_PAGE_SIZES,
  PagerWithSize
} from '@components/UI/PagerWithSize/PagerWithSize.component';
import { PageTitle } from '@components/UI/PageTitle/PageTitle.component';
import { API_ENDPOINT } from '@shared/constants/api-endpoints';
import { useFetch } from '@shared/hooks/useFetch';
import { useTranslationHelper } from '@shared/hooks/useTranslationsHelper';
import { PageableDTO } from '@shared/models/PageableDTO.model';
import { MdcGrid } from 'ids-wc/dist/react/components';
import { Fragment, useEffect } from 'react';

const DEFAULT_PAGINATION = { page: PAGER_FIRST_PAGE, pageSize: PAGER_PAGE_SIZES[0] };

const IRISPaymentHistory = () => {
  const { t } = useTranslationHelper('IRISPaymentHistory');

  const {
    get: getIRISPaymentHistory,
    response: list,
    loading
  } = useFetch<PageableDTO<IRISPaymentHistoryItem> | null>(API_ENDPOINT.IRIS_PAYMENTS_LIST);

  useEffect(() => {
    getIRISPaymentHistory({ queryParams: { ...DEFAULT_PAGINATION } });
  }, [getIRISPaymentHistory]);

  const onPagerChange = (pageSize: number, page: number) => {
    getIRISPaymentHistory({
      queryParams: { pageSize, page }
    });
  };

  return (
    <Fragment>
      <TopNavigationActions />
      <MdcGrid row className="mb-1">
        <MdcGrid col={12}>
          <PageTitle title={t('title')} />
        </MdcGrid>
      </MdcGrid>

      <List data={list?.content as IRISPaymentHistoryItem[]} loading={loading} />
      <PagerWithSize total={list?.meta.total} onChange={onPagerChange} />
    </Fragment>
  );
};

export default IRISPaymentHistory;
